/*
 * @Description: 账号余额
 */
<template>
    <div id="series-detail">
        <!-- 顶部header模块 -->
        <header slot="header" class="c-body-header">
            <div class="header-row">
            </div>
            <div class="header-row">
                <div class="header-row-left">
                    <!-- 搜索 -->
                    <Input
                        v-model="tableParams.keyword"
                        placeholder="请输入客户名"
                        class="header-search"
                        icon="android-search"
                        @on-keydown.enter="getList(1)"
                        @on-click="getList(1)"
                    />
                </div>
            </div>
        </header>
        <!-- 顶部header模块 -->
        <!-- 主体section模块 -->
        <section slot="section" class="c-body-section">
            <template>
                <el-table
                    :data="originData"
                    style="width: 100%;border:1px solid #EBEEF5"
                    >
                        <el-table-column fixed prop="publisherId" label="广告主id" min-width="200"> </el-table-column>
                        <el-table-column fixed prop="userName" label="用户名" min-width="300"> </el-table-column>
                        <el-table-column fixed prop="email" label="用户邮箱" min-width="300"> </el-table-column>
                        <el-table-column fixed prop="balance" label="用户余额" width="200"> </el-table-column>
                        <el-table-column fixed prop="create_time" label="时间" min-width="200"> </el-table-column>
                </el-table>
            </template>

            <div class="el_TablePage">
                <el-pagination
                    background
                    layout="sizes,prev, pager, next"
                    :total="pageBean.totalNum"
                    @current-change="getList"
                    @size-change="(e)=>{this.tableParams.pageSize = e,this.getList(1)}">
                </el-pagination>
            </div>

        </section>



        



    </div>
</template>
<script>
import mixins from '@/mixins/index.js';
import { mapState } from 'vuex';
import Vue from 'vue';

export default {
    name: 'managementSeries',
    mixins: [mixins],
    components: {
    },
    props: {
        tagSeries: {
            type: Number,
        },
    },
    data() {
        return {
            self:this,
            //推广列表数据
            originData: [],
            //分页对象
            pageBean: {
                currentPage: 1,
                pageSize: 10,
                startNum: 0,
                totalNum: 0,
                totalPage: 1,
            },
            //获取推广列表的参数
            tableParams: {
                page: 1,
                pageSize: 10,
                keyword: '',
            },

        };
    },
    watch: {

    },
    computed: {

    },
    mounted() {
        this.getList(false, true);
    },
    methods: {


        /**
         * @desc 报表下载
         */
        onClickDown() {
            const params = { ...this.tableParams };
            let queryString = `${this.$port.seriesTable.seriesListDownLoad}?`;
            for (let i in params) queryString += `${i}=${params[i]}&`;
            let columns = [];
            for (let i in this.columns1) {
                this.indicatorList[i].forEach((item) => {
                    columns.push(item.code);
                });
            }
            queryString += `columns=id,name,${columns.join(',')}`;
            window.location.href = queryString;
        },


        /**
         * @desc: 获取推广数据
         * @param {Boolean} isInit: 是否初始化页数
         * @param {Boolean} isLoad: 是否是加载页面
         */
        async getList(isInit, isLoad) {
          
            if (!isInit) {this.tableParams.page = 1}else{this.tableParams.page = isInit};
            //获取表格数据 -获取汇总数据
            let params = { ...this.tableParams };

            const resList = await this.$axios.get(this.$port.pmt.balanceAll, { params });
            if (resList.data.pageBean) this.pageBean = resList.data.pageBean;
            if (resList.data.list) {
                // const selectArray = this.$store.state.manageData.series.selectArray;
                this.originData = resList.data.list
            }
        },




    },
};
</script>
<style lang="scss">
.manage-input-box {
    .ivu-icon-ios-calendar-outline {
        &:before {
            content: '\F3F3' !important;
        }
    }
}
#series-detail {
    .header-search {
        width: 3rem !important;
    }
    #c-body .c-body-section .c-body-table .table-tr {
        .table-td-primary {
            min-width: 0.4rem;
        }
        .table-td-primary:nth-of-type(1) {
            padding-right: 0;
            padding-left: 0.2rem;
        }
        //展示删除创意按钮
    }
    .edit-box {
        justify-content: flex-end;
        display: flex;
        width: 2.5rem;
        position: relative;
        align-items: center;
        .edit {
            width: 2.5rem;
            height: 100%;
            display: flex;
            align-items: center;
            position: absolute;
            flex: 1;
            .close-btn {
                cursor: pointer;
                position: absolute;
                right: 1.2rem;
            }
        }
    }

    .flex-text-title {
        overflow: auto;
        text-overflow: initial;
        white-space: normal;
        max-width: none;
    }



    .image-list{
        margin: 0; 
        padding: 0;
        display:none;
        }

        .image-list li {
            display: inline-block;
            margin: 0 10px;
            list-style: none;
            position: relative;
        }

        .image-list li img {
        box-shadow: 0 0 5px #333;
        }

        .icon-remove{

            width: 20px; 
            height:20px;
            text-align: center; line-height: 20px;
            background:#f33;
            position:absolute; top:-10px; right:-10px;
            border-radius: 10px;
            cursor: pointer;
            color:#fff;
        }
        a {
        color: #42b983;
    }
    .ivu-page-item-active a{color:#fff}


}






</style>



// WEBPACK FOOTER //
// src/view/Payment/Balance.vue